"use client";

import type React from "react";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth-context";
import { authClient } from "@/lib/auth-client";
import Link from "next/link";
import { set } from "date-fns";

export function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { data:user } = authClient.useSession()
 
  const router = useRouter();
 if(user) {
    router.push("/app/")
  }
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    if (!email || !password) {
      setError("Please fill in all fields");
      return;
    }

    const success = await authClient.signIn.email({
      email,
      password,
    });
    if (success.data?.user.id) {
      setIsLoading(false);
      router.push("/app/");
    } else {
      setIsLoading(false);
      setError("Invalid email or password", success.error);
    }
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="space-y-1">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">Mahlia</h1>
          <p className="text-muted-foreground mt-2">Welcome back to our community</p>
        </div>
        {/* <CardTitle className="text-2xl font-bold">Sign In</CardTitle> */}
        <CardDescription>
          Enter your credentials to access your account
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="sarah@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="space-y-2 text-right">
            <Link href={"/password-reset"}>
              <Label htmlFor="password">Forgot password?</Label>
            </Link>
          </div>
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Signing In...
              </>
            ) : (
              "Sign In"
            )}
          </Button>
        </form>

        <div className="mt-6 text-center text-sm">
          <span className="text-muted-foreground">Don't have an account? </span>
          <Link href="/register" className="text-primary hover:underline">
            Sign up
          </Link>
        </div>

        {/* <div className="mt-4 p-3 bg-muted rounded-lg">
          <p className="text-sm text-muted-foreground mb-2">
            Demo Credentials:
          </p>
          <p className="text-xs">Email: sarah@example.com</p>
          <p className="text-xs">Password: password</p>
        </div> */}
      </CardContent>
    </Card>
  );
}
